module.exports = __webpack_public_path__ + "static/img/penguin.7f67a0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/penguin.png
// module id = 2999
// module chunks = 1